/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AarOrganizationResponse
 */
export interface AarOrganizationResponse {
    /**
     * 
     * @type {string}
     * @memberof AarOrganizationResponse
     */
    legalEntity?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AarOrganizationResponse
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AarOrganizationResponse
     */
    organizationNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AarOrganizationResponse
     */
    shortName?: string | null;
}

/**
 * Check if a given object implements the AarOrganizationResponse interface.
 */
export function instanceOfAarOrganizationResponse(value: object): value is AarOrganizationResponse {
    return true;
}

export function AarOrganizationResponseFromJSON(json: any): AarOrganizationResponse {
    return AarOrganizationResponseFromJSONTyped(json, false);
}

export function AarOrganizationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AarOrganizationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'legalEntity': json['legalEntity'] === undefined ? undefined : json['legalEntity'] === null ? null : json['legalEntity'],
        'name': json['name'] === undefined ? undefined : json['name'] === null ? null : json['name'],
        'organizationNumber': json['organizationNumber'] === undefined ? undefined : json['organizationNumber'] === null ? null : json['organizationNumber'],
        'shortName': json['shortName'] === undefined ? undefined : json['shortName'] === null ? null : json['shortName'],
    };
}

export function AarOrganizationResponseToJSON(json: any): AarOrganizationResponse {
    return AarOrganizationResponseToJSONTyped(json, false);
}

export function AarOrganizationResponseToJSONTyped(value?: AarOrganizationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'legalEntity': value['legalEntity'],
        'name': value['name'],
        'organizationNumber': value['organizationNumber'],
        'shortName': value['shortName'],
    };
}

